import type { SetupSettings } from "../SetupDropdown";
import { SetupDropdown } from "../SetupDropdown";
import React, { useState } from "react";
import { AutomationUI } from "../../src";
import { SolutionColors } from "@smartsuite/types/lib/constants/color";

export const Demo = (): React.ReactElement => {
  // Local-dev seeds only: REACT_APP_* values are inlined into the bundle by
  // vite, so REACT_APP_ACCESS_TOKEN must never be set in production builds —
  // in prod the token arrives via the `accessToken` prop from the host app.
  const [value, setValue] = useState<SetupSettings>({
    accountId:
      localStorage.getItem("accountId") ??
      process.env.REACT_APP_ACCOUNT_ID ??
      "",
    accessToken:
      localStorage.getItem("accessToken") ??
      process.env.REACT_APP_ACCESS_TOKEN ??
      "",
    solutionId:
      localStorage.getItem("solutionId") ??
      process.env.REACT_APP_SOLUTION_ID ??
      "",
    engineUrl:
      localStorage.getItem("engineUrl") ??
      process.env.REACT_APP_ENGINE_URL ??
      "",
    limitsUrl:
      localStorage.getItem("limitsUrl") ??
      process.env.REACT_APP_LIMITS_URL ??
      "",
    lang: localStorage.getItem("automationsUILang") ?? "en",
    logoColor: SolutionColors.basePrimaryBlue,
    smartsuiteBackendUrl:
      process.env.REACT_APP_SS_BACKEND_URL ??
      localStorage.getItem("smartsuiteBackendUrl") ??
      "",
  });

  const [isOpenAutomationUi, setIsOpenAutomationUi] = useState(true);

  const set = (settings: SetupSettings): void => {
    setValue(settings);
    localStorage.setItem("accountId", settings.accountId);
    localStorage.setItem("accessToken", settings.accessToken);
    localStorage.setItem("solutionId", settings.solutionId);
    localStorage.setItem("engineUrl", settings.engineUrl);
    localStorage.setItem("limitsUrl", settings.limitsUrl);
    localStorage.setItem("automationsUILang", settings.lang);
    localStorage.setItem("smartsuiteBackendUrl", settings.smartsuiteBackendUrl);
  };

  return (
    <React.StrictMode>
      <SetupDropdown
        value={value}
        setValue={set}
        openAutomation={() => setIsOpenAutomationUi(true)}
      />
      {isOpenAutomationUi && (
        <AutomationUI
          accountId={value.accountId}
          solutionId={value.solutionId}
          accessToken={value.accessToken}
          engineUrl={value.engineUrl}
          limitsUrl={value.limitsUrl}
          lang={value.lang}
          logoColor={value.logoColor}
          originRoute="/"
          smartsuiteBackendUrl={value.smartsuiteBackendUrl}
          onClose={() => {
            setIsOpenAutomationUi(false);
            history.back();
          }}
        />
      )}
    </React.StrictMode>
  );
};
